var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b ||= {})
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __objRest = (source, exclude) => {
  var target = {};
  for (var prop in source)
    if (__hasOwnProp.call(source, prop) && exclude.indexOf(prop) < 0)
      target[prop] = source[prop];
  if (source != null && __getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(source)) {
      if (exclude.indexOf(prop) < 0 && __propIsEnum.call(source, prop))
        target[prop] = source[prop];
    }
  return target;
};

// src/components/Button/Button.tsx
import { forwardRef } from "react";
import { jsx } from "react/jsx-runtime";
var Button = forwardRef((props, ref) => {
  const _a = props, {
    size = "large",
    variant,
    onDark = false,
    className,
    children
  } = _a, rest = __objRest(_a, [
    "size",
    "variant",
    "onDark",
    "className",
    "children"
  ]);
  const attributes = {
    [`data-variant-${variant}`]: "",
    [`data-size-${size}`]: ""
  };
  if (onDark) {
    attributes[`data-on-dark`] = "";
  }
  return /* @__PURE__ */ jsx("button", __spreadProps(__spreadValues(__spreadValues({ ref, className: ["rna-button", className == null ? void 0 : className.trim()].filter((x) => !!x).join(" ") }, attributes), rest), { children }));
});
Button.displayName = "Button";
export {
  Button
};
